module.exports = __webpack_public_path__ + "static/media/create-story-icon-purple.bc7fb04d.png";